<template>
  <div class="cartDropdownContent">
    <div class="cartDropdownContent__inner">
      <div class="cartDropdownContent__header">
        <div class="cartDropdownContent__headerImage" />
        <div class="cartDropdownContent__headerName">Nazwa</div>
        <div class="cartDropdownContent__headerCount">Ilość</div>
        <div class="cartDropdownContent__headerValue">Wartość</div>
      </div>
      <div v-if="cartData" class="cartDropdownContent__list prettyScrollbar">
        <ProductCartDropdown
          v-for="item in cartData.items"
          :key="`${item.id}_${item.quantity}`"
          :product="item"
        />
      </div>
    </div>
    <div class="cartDropdownContent__details">
      <div v-if="cartData.deliveryFee" class="cartDropdownContent__detailsItem">
        <span>Przesyłka:</span>
        <span v-if="cartData.minimalDeliveryFee">
          od
          <b>
            {{ cartData.minimalDeliveryFee.currencyPrefix }}
            {{
              showNetPrices
                ? cartData.minimalDeliveryFee.netFormatted
                : cartData.minimalDeliveryFee.grossFormatted
            }}
          </b>
          {{ cartData.minimalDeliveryFee.currencyPostfix }}
          {{ showNetPrices ? $t('net') : $t('gross') }}
        </span>
        <span v-else>
          <b>
            {{ cartData.deliveryFee.currencyPrefix }}
            {{
              showNetPrices
                ? cartData.deliveryFee.netFormatted
                : cartData.deliveryFee.grossFormatted
            }}
          </b>
          {{ cartData.deliveryFee.currencyPostfix }}
          {{ showNetPrices ? $t('net') : $t('gross') }}
        </span>
      </div>
      <div
        v-if="cartData.giftsValue && cartData.giftsValue.gross"
        class="cartDropdownContent__detailsItem"
      >
        <span>Gratis:</span>
        <span>
          <b>
            {{ cartData.giftsValue.currencyPrefix }}
            {{
              showNetPrices ? cartData.giftsValue.netFormatted : cartData.giftsValue.grossFormatted
            }}</b
          >
          {{ cartData.giftsValue.currencyPostfix }}
          {{ showNetPrices ? $t('net') : $t('gross') }}
        </span>
      </div>
    </div>
    <div class="cartDropdownContent__footer">
      <div class="cartDropdownContent__footerPrice">
        <div class="cartDropdownContent__footerPriceText">{{ $t('totalAmount') }}:</div>
        <div class="cartDropdownContent__footerPriceNet">
          <b>
            {{ cartData.grandTotal.currencyPrefix }}
            {{
              showNetPrices ? cartData.grandTotal.netFormatted : cartData.grandTotal.grossFormatted
            }}
          </b>
          {{ cartData.grandTotal.currencyPostfix }}
          {{ showNetPrices ? $t('net') : $t('gross') }}
          <div
            v-if="showNetPrices"
            class="cartDropdownContent__footerPriceNet cartDropdownContent__footerPriceNet--small"
          >
            <b>
              {{ cartData.grandTotal.currencyPrefix }}
              {{ cartData.grandTotal.grossFormatted }}
            </b>
            {{ cartData.grandTotal.currencyPostfix }}
            {{ $t('gross') }}
          </div>
        </div>
      </div>
      <div class="cartDropdownContent__footerButtons">
        <div class="cartDropdownContent__footerButtonWrapper">
          <v-button
            :to="
              editOrderId
                ? localePath({
                    name: 'dashboard-orders-slug',
                    params: { slug: editOrderId },
                  })
                : localePath({ name: 'cart' })
            "
            :text="editOrderId ? 'Przejdź do zamówienia' : $t('myCart')"
            theme="purple"
            class="cartDropdownContent__footerButton"
          />
        </div>
      </div>
      <div
        v-if="
          cartData.missingAmountForFreeDelivery && cartData.missingAmountForFreeDelivery.net > 0
        "
        class="cartDropdownContent__footerItem cartDropdownContent__footerItem--color"
      >
        <span>Do darmowej przesyłki brakuje:</span>
        <span>
          <strong>
            {{ cartData.deliveryFee.currencyPrefix }}
            {{
              showNetPrices
                ? cartData.missingAmountForFreeDelivery.netFormatted
                : cartData.missingAmountForFreeDelivery.grossFormatted
            }}
          </strong>
          {{ cartData.deliveryFee.currencyPostfix }}
          {{ showNetPrices ? $t('net') : $t('gross') }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import costCentersMixin from '~/mixins/costCenters';
import cartMixin from '~/mixins/cart';
import VButton from '~/components/VButton';
import ProductCartDropdown from '@/components/Product/ProductCartDropdown';

export default {
  name: 'CartDropdownContent',
  components: {
    ProductCartDropdown,
    VButton,
  },
  mixins: [cartMixin, costCentersMixin],
  data() {
    return {
      tabsNavigation: [{ title: 'Zwroty i reklamacje' }, { title: 'Moje zwroty i reklamacje' }],
      cmsSection: '',
    };
  },
  computed: {
    ...mapGetters('auth', ['showNetPrices']),
  },
};
</script>
<style lang="scss">
.cartDropdownContent {
  &__header {
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 700;
    display: flex;
    border-bottom: 1px solid $cLightGrey;
    padding-bottom: 1.5rem;
  }

  &__headerImage {
    flex: 0 0 12%;
    max-width: 12%;
  }

  &__headerName {
    flex: 0 0 33%;
    max-width: 33%;
  }

  &__headerCount {
    flex: 0 0 25%;
    max-width: 25%;
    text-align: center;
  }

  &__headerValue {
    flex: 0 0 30%;
    max-width: 30%;
    text-align: center;
  }

  &__inner {
    padding: 1.5rem 1.5rem 0 1.5rem;
  }

  &__title {
    padding-bottom: 1.5rem;
    font-size: 1.5rem;
    line-height: 1.9rem;
    font-weight: 700;
    border-bottom: 1px solid $cAddLight;
  }

  &__empty {
    margin-top: 2.5rem;
    margin-bottom: 5rem;
  }

  &__list {
    overflow: auto;
    height: 100%;
    max-height: 30rem;
    width: calc(100% + 10px);
    padding-right: 5px;

    @include rwd('ultra') {
      height: 20rem;
    }
  }

  &__details {
    padding: 2.1rem 2.5rem 1.2rem 2.5rem;
    box-shadow: 0 -10px 20px rgba(23, 25, 51, 0.05);
    background-color: $cWhite;
  }

  &__detailsItem,
  &__footerItem {
    display: flex;
    justify-content: flex-end;
    max-width: 36rem;
    margin-left: auto;
    font-size: 1.4rem;
    line-height: 2.2rem;

    span {
      &:last-child {
        width: 15rem;
        text-align: right;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    strong {
      font-weight: 500;
      font-family: $fSecond;
    }

    &--color {
      color: $cMain;
    }
  }

  &__footer {
    padding: 0 2.5rem 2.5rem 2.5rem;
  }

  &__footerPrice {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 1.4rem;
    line-height: 2.2rem;
    width: 36rem;
    margin-left: auto;
    border-top: 1px solid $cLightGrey;
    text-align: right;
    padding-top: 1.5rem;
  }

  &__footerPriceText {
    font-weight: 700;
  }

  &__footerPriceNet {
    font-family: $fSecond;
    text-align: right;
    width: 15rem;

    b {
      font-size: 1.8rem;
      font-weight: 500;
    }

    &--small {
      color: $cAddDark02;
      font-size: 1.2rem;

      b {
        font-size: 1.4rem;
      }
    }
  }

  &__footerPriceGross {
    font-family: $fSecond;
    font-size: 1.2rem;
    line-height: 1.4rem;
    color: $cAddDark02;
  }

  &__footerButtons {
    display: flex;
    margin-top: 2.4rem;
    margin-left: -5px;
    margin-right: -5px;
  }

  &__footerButtonWrapper {
    flex: 1;
    padding-left: 5px;
    padding-right: 5px;
  }

  &__footerButton {
    white-space: nowrap;
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  &__footerItem {
    margin-top: 1rem;
  }
}
</style>
